import React, { Component } from 'react'
import Fade            from 'react-reveal/Fade'
//

export default class Lateral extends Component {
    constructor(){
        super()
    }

    render() {
        return (
            <Fade duration={500} spy={ this.props.label }>
                <div className="lateral">
                    <span className="lateral__label">{ this.props.label }</span>
                </div>
            </Fade>
        )
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Lateral.js